<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="box">
          <div class="box-header b-b">
            <h5>Hourly Sales Report</h5>
            <small>Shows cumulative sales by hour</small>
          </div>
          <div class="box-tool">
            <ul class="nav">
              <li class="nav-item inline dropdown">
                <a
                  data-toggle="dropdown"
                  class="btn btn-default">Export</a>
                <div class="dropdown-menu dropdown-menu-scale pull-right">
                  <span class="dropdown-header">Export As</span>
                  <a
                    class="dropdown-item"
                    @click.prevent="exportAsFile('CSV')">CSV</a>
                  <a
                    class="dropdown-item"
                    @click.prevent="exportAsFile('PDF')">PDF</a>
                </div>
              </li>
            </ul>
          </div>
          <div class="box-body">
            <vue-apex-charts
              :options="chartOptions"
              :series="chartSeries"
              height="400px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import VueApexCharts from 'vue-apexcharts';
import fileDownload from 'js-file-download';

export default {
    components: {
        VueApexCharts,
    },

    props: {
        Currency: {
            type: String,
            default: 'RM',
        },
    },

    data() {
        return {
            export_filename: 'Hourly Sales Report',
            loading: true,
            cumulativeSales: [],
            sales: [],
            xAxisSales: [],
        };
    },

    computed: {
        ...mapGetters(['dateFilter', 'typeDate']),
        ...mapState('hourly', ['filters']),

        api() {
            return Laroute.route('franchise.report.hourly.getHourlySummary', {
                id: this.outlet,
                typeDate: this.$store.getters.typeDate,
            });
        },

        outlet() {
            return this.$store.getters.activeOutlet;
        },

        chartOptions() {
            return {
                chart: {
                    toolbar: {
                        show: false,
                    },
                    zoom: {
                        enabled: false,
                    },
                    type: 'line',
                    stacked: false,
                },
                dataLabels: {
                    enabled: false,
                },
                colors: ['#0cc2aa', '#D10543'],
                stroke: {
                    width: [4, 4],
                },
                markers: {
                    size: 5,
                },

                xaxis: {
                    categories: this.xAxisSales,
                },

                yaxis: [
                    {
                        seriesName: 'Sales',
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                        },
                        title: {
                            text: 'Sales',
                        },
                        labels: {
                            formatter: function(value) {
                                return value;
                            },
                        },
                    },
                    {
                        opposite: true,
                        seriesName: 'Cumulative Sales',
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                        },
                        labels: {
                            formatter: function(value) {
                                return value;
                            },
                        },
                    },
                ],

                tooltip: {
                    enabled: true,
                    shared: false,
                    intersect: true,
                    x: {
                        show: true,
                    },
                    marker: {
                        show: true,
                        shape: 'circle',
                    },
                },
                legend: {
                    horizontalAlign: 'left',
                    offsetX: 40,
                },
            };
        },

        chartSeries() {
            return [
                {
                    name: 'Sales',
                    type: 'column',
                    data: this.sales,
                },
                {
                    name: 'Cumulative Sales',
                    type: 'line',
                    data: this.cumulativeSales,
                },
            ];
        },

        options() {
            return {
                outlet_id: this.$store.getters.activeOutlet,
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
                filters: this.filters,
                typeDate: localStorage.getItem('timezones'),
                timezoneDevice: Intl.DateTimeFormat().resolvedOptions()
                    .timeZone,
            };
        },
    },

    watch: {
        dateFilter(a, b) {
            if (a === b) return;
            this.getSummary();
        },

        filters: function(to, from) {
            if (to === from) return;
            this.getSummary();
        },
    },

    mounted() {
        this.getSummary();
        $(this.$el).tooltip({
            selector: '[data-toggle="tooltip"]',
        });
    },

    methods: {
        getSummary() {
            var that = this;
            this.loading = true;

            this.$http.post(this.api, this.options).then(response => {
                var data = response.data;

                that.xAxisSales = data.graph_data.total_sales.map(obj =>
                    moment(obj.date).format('HH'),
                );

                that.sales = data.graph_data.total_sales.map(obj => obj.total);

                that.cumulativeSales = data.graph_data.total_sales.map(
                    obj => obj.cumulative,
                );

                this.loading = false;
            });
        },

        exportAsFile(type) {
            let url = Laroute.route('franchise.report.hourly.exportGraphData', {
                id: this.outlet,
                type: type,
            });

            this.$http({
                url: url,
                responseType: 'blob',
                method: 'post',
                headers: { Accept: 'multipart/form-data' },
                data: this.options,
            }).then(response => {
                fileDownload(response.data, `${this.export_filename}.${type}`);
            });
        },

        formatNumber(number) {
            return numeral(number).format('0,0');
        },
    },
};
</script>

<style lang="scss" scoped>
.echarts {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/hourly/vue_hourly.vue